import React, {Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../../Escritorio/Instrucciones';
import AyudaEstructuraOperaciones from '../AyudaEstructuraOperaciones';
import useConfigAuth from '../../../../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexCuz, FlexFull, InputM83Bis, ImgB10, DivM83, NumRedondo, NumCuadrado, InputCuadrado, InputRedondo, NumberDivR, NumberDivL, ImgDiv, NumCalculoM83, AvanzarBtn, AvanzarImg } from '../../../../../Css/StyledMatematica';

const instrucciones = 'Resuelve la suma.';
const miniInstrucciones = 'Resuelve la suma.';

const M62Practica = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [lanzoEffect, setLanzoEffect] = useState(false);
    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [digitoU1, setDigitoU1] = useState('');
    const [digitoD1, setDigitoD1] = useState('');
    const [digitoU2, setDigitoU2] = useState('');
    const [digitoD2, setDigitoD2] = useState('');
    const [digitoFinalUno, setDigitoFinalUno] = useState('');
    const [digitoFinalDos, setDigitoFinalDos] = useState('');
    const [numeroUnidadUno, setNumeroUnidadUno] = useState('');
    const [numeroUnidadDos, setNumeroUnidadDos] = useState('');
    const [numeroDecenaUno, setNumeroDecenaUno] = useState('');
    const [numeroDecenaDos, setNumeroDecenaDos] = useState('');
    const [numeroFinalUno, setNumeroFinalUno] = useState('');
    const [numeroFinalDos, setNumeroFinalDos] = useState('');
    const [numeroFinal, setNumeroFinal] = useState('');
    const [indexes, setIndexes] = useState();
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [tipoEjercicio, setTipoEjercicio] = useState('');

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const ayuVisualSolicitada = useSelector(state => state.configuracion.ayuda_visual);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const onSubmit = (e) => {
        e.preventDefault();
    }

    const verificar = (e) => {
        e.preventDefault();
        if(numeroUnidadUno.toString() !== digitoU1.toString() || numeroUnidadDos.toString() !== digitoU2.toString() || numeroDecenaUno.toString() !== digitoD1.toString() || numeroDecenaDos.toString() !== digitoD2.toString() || digitoFinalUno.toString() !== numeroFinalUno.toString() || digitoFinalDos.toString() === !numeroFinalDos.toString() || (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString() !== numeroFinal.toString()) {
            console.log('mal');
            setDisable(true);
            setContarErrores(contarErrores + 1);
            setIsIncorrect(true);
            setTimeout(() => {
                setIsIncorrect(false);
            }, 300);
            TryAgain();
            setTimeout(() => {
                setDisable(false);
                if(numeroUnidadUno.toString() !== digitoU1.toString() || numeroUnidadDos.toString() !== digitoU2.toString() || numeroDecenaUno.toString() !== digitoD1.toString() || numeroDecenaDos.toString() !== digitoD2.toString() || digitoFinalUno.toString() !== numeroFinalUno.toString() || digitoFinalDos.toString() === numeroFinalDos.toString() || (comparar[count-1].cantidad_1 + comparar[count-1].cantidad_2).toString() === numeroFinal.toString()) {
                    setNumeroUnidadUno(0);
                    setNumeroDecenaUno(0);
                    setNumeroUnidadDos(0);
                    setNumeroDecenaDos(0);
                    setNumeroFinalUno(0);
                    setNumeroFinalDos(0);
                    setNumeroFinal(0);
                }
            }, 300);
        } else {
            console.log("bien");
            setDisable(true);
            setIsCorrect(true);
            setTimeout(() => {
                setIsCorrect(false);
            }, 300);
            GoodWork();
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setNumeroUnidadUno(0);
                    setNumeroDecenaUno(0);
                    setNumeroUnidadDos(0);
                    setNumeroDecenaDos(0);
                    setNumeroFinalUno(0);
                    setNumeroFinalDos(0);
                    setNumeroFinal(0);
                    setDigitoU1(0);
                    setDigitoD1(0);
                    setDigitoU2(0);
                    setDigitoD2(0);
                    setDigitoFinalUno(0);
                    setDigitoFinalDos(0);
                    setCount(count + 1);
                }, 300);
            } else {
                setTimeout(() => {
                    setUltimoTiempo(true);
                    dispatch( finalizarEjercicioAction() );
                }, 1500);
            }
        }
    }

    useEffect(() => {
        const min = 10;
        const max = 89;
        const randomNumeroUno = Math.floor(Math.random() * (max - min +1)) + min;
        const randomNumeroDos = (function () {
            const u1 = Number(randomNumeroUno.toString().substring(1,2));
            const d1 = Number(randomNumeroUno.toString().substring(0,1));
            const minU = 0;
            const maxU = 10-u1;
            const u2 = Math.floor(Math.random() * (maxU - minU )) + minU;
            const minD = 1;
            const maxD = 9-d1;
            let d2;
            d2 = Math.floor(Math.random() * (maxD - minD +1));
            if(d2 === 0) {
                d2 = 1;
            }
            const numero = Number(d2.toString().concat(u2.toString()));
            return numero;
        })();
        const modelo = [
            {id:'1', cantidad_1:randomNumeroUno, cantidad_2:randomNumeroDos}
        ]
        setComparar(modelo);
        setLanzoEffect(true);
        setIndexes(modelo.length);
        setTipoEjercicio('suma_descomposicion');
    }, []);

    useEffect(() => {
        if(comparar.length === 0){
            return;
        }
        const newList = JSON.parse(JSON.stringify(comparar[count-1]));
        if(newList.cantidad_1.toString().length === 2 ){
            setDigitoU1(newList.cantidad_1.toString().substring(1,2));
            setDigitoD1((Number(newList.cantidad_1.toString().substring(0,1))*10).toString());
        }
        if(newList.cantidad_1.toString().length === 1 ){
            setDigitoU1(newList.cantidad_1.toString().substring(0,1));
        }
        if(newList.cantidad_2.toString().length === 2 ){
            setDigitoU2(newList.cantidad_2.toString().substring(1,2));
            setDigitoD2((Number(newList.cantidad_2.toString().substring(0,1))*10).toString());
        }
        if(newList.cantidad_2.toString().length === 1 ){
            setDigitoU2(newList.cantidad_2.toString().substring(0,1));
        }
        setDigitoFinalUno((newList.cantidad_1 + newList.cantidad_2).toString().substring(1,2));
        setDigitoFinalDos(((Number(newList.cantidad_1.toString().substring(0,1))*10) + (Number(newList.cantidad_2.toString().substring(0,1))*10)).toString());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count, lanzoEffect]);

    useEffect(() => {
        dispatch(setearEjercicioAction('M62Practica') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/suma/suma-descomposicion/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(lanzoEffect === false){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lanzoEffect, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'ejercicio': "M62Practica",
                    'errores': contarErrores,
                    'tiempo': tiempoFinal,
                    'id_paciente': id_paciente,
                    'ayuda_visual': ayuVisualSolicitada,
                    'tipo': tipoEjercicio,
                    sesion
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);
    
    return (
        <Fragment>
            {props.mostrar ? 
            null
            :
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            }
            {iniciar
                ?
                <Fragment>
                    <FlexFull justify='space-evenly' align='center'
                        isCorrect={isCorrect}
                        isIncorrect={isIncorrect}
                    >
                        <FlexFull direction='column' justify='space-around' align='start' width='48vw' height='75vh'>
                            {/* CALCULO */}
                            {comparar.length === 0 ? null :
                            <FlexFull justify='end' align='center' width='100%'> {/*  border='2px solid blue' */} 
                                <FlexFull justify='space-around' align='center'> {/*  border='2px solid green' */} 
                                    <NumCalculoM83 color='#D76970'>{comparar[count-1].cantidad_1}</NumCalculoM83>
                                    <NumCalculoM83 color='#646464'>+</NumCalculoM83>                                     
                                    <NumCalculoM83 color='#23AAAF'>{comparar[count-1].cantidad_2}</NumCalculoM83>
                                    <NumCalculoM83 color='#646464'>=</NumCalculoM83>         
                                    <form onSubmit={(e) => onSubmit(e)}>
                                        <InputM83Bis type="text" value={numeroFinal} disabled={true} />
                                    </form>
                                </FlexFull>
                            </FlexFull>
                            }
                            {/* FIN CALCULO */}

                            {/* DESCOMPOSICIÓN */}
                            <FlexFull justify='space-around' align='center' margin='-120px 0vw 0vh 0px' mm='-110px 0vw 0vh 0px' mt='-110px 0vw 0vh -5px' md='-100px 0vw 0vh -5px' mlg='-75px 0vw 0vh 15px' > {/* width='35vw' border='3px solid blue' */}
                                <Flex direction='column' width='10vw' minw='15vw' height='30vh' margin='0vh 2vw 0vh 0vw' mt='0px 1.5vw 0vh 0px' md='0px 1.2vw 0vh 0px' mlg='0px 2.3vw 0vh 0px'> { /* border='3px solid violet'     mt='0vh 1.5vw 0vh 0vw' mlg='0px' */}
                                <div>
                                    <ImgDiv>
                                        <ImgB10 src={`/img/lineasDescomposicion.png`} w='55%' h='14vh' hm='14vh' hlg='17vh' />
                                    </ImgDiv>
                                    <Flex>
                                        <NumberDivL>
                                            <NumRedondo>
                                                <InputRedondo type="text" value={numeroDecenaUno} onChange={(e) => setNumeroDecenaUno(e.target.value)} disabled={disable} />
                                            </NumRedondo>
                                        </NumberDivL>
                                    
                                        <NumberDivR>
                                            <NumCuadrado>
                                                <InputCuadrado type="text" value={numeroUnidadUno} onChange={(e) => setNumeroUnidadUno(e.target.value)} disabled={disable} />
                                            </NumCuadrado>
                                        </NumberDivR>
                                    </Flex>
                                </div>
                                </Flex>
                                <Flex direction='column' width='10vw' minw='15vw' height='30vh' margin='0vh 0vw 0vh 2vw' mlg='0px'>  { /*   margin='0vh 0vw 0vh 4vw'   border='1px solid green' */}
                                <div>
                                    <ImgDiv>
                                        <ImgB10 src={`/img/lineasDescomposicion.png`} w='55%' h='14vh' hm='14vh' hlg='17vh' />
                                    </ImgDiv>
                                    <Flex>
                                        <NumberDivL>
                                            <NumRedondo>
                                                <InputRedondo type="text" value={numeroDecenaDos} onChange={(e) => setNumeroDecenaDos(e.target.value)} disabled={disable} />
                                            </NumRedondo>
                                        </NumberDivL>
                                        <NumberDivR>
                                            <NumCuadrado>
                                                <InputCuadrado type="text" value={numeroUnidadDos} onChange={(e) => setNumeroUnidadDos(e.target.value)} disabled={disable} /> 
                                            </NumCuadrado>
                                        </NumberDivR>
                                    </Flex>
                                </div>
                                </Flex>
                            </FlexFull>
                            {/* FIN DESCOMPOSICIÓN */}

                            {/* CALCULO ABAJO */}
                            <FlexFull justify='center' align='center' width='100%'> 
                                <FlexFull justify='space-around' align='center'>
                                    <DivM83>
                                        <div>
                                            <InputRedondo type="text" value={numeroFinalDos} onChange={(e) => setNumeroFinalDos(e.target.value)} disabled={disable} />
                                        </div>
                                    </DivM83>
                                    <DivM83>
                                        <NumCalculoM83 color='#646464'>+</NumCalculoM83>
                                    </DivM83>
                                    <DivM83>
                                        <div>
                                            <InputCuadrado type="text" value={numeroFinalUno} onChange={(e) => setNumeroFinalUno(e.target.value)} disabled={disable} />
                                        </div>
                                    </DivM83>
                                    <DivM83>
                                        <NumCalculoM83 color='#646464'>=</NumCalculoM83>
                                    </DivM83>
                                    <DivM83>
                                        <InputCuadrado type="text" value={numeroFinal} onChange={(e) => setNumeroFinal(e.target.value)} disabled={disable} />
                                    </DivM83>
                                </FlexFull>
                            </FlexFull>
                            {/* FIN CALCULO ABAJO */}
                        </FlexFull>
                        {/* AYUDA */}
                        <FlexFull direction='column' justify='center' align='center' width='25vw' height='80vh'>
                            <AyudaEstructuraOperaciones tipo={tipoEjercicio} />
                        </FlexFull>
                        {/* FIN AYUDA */}
                    </FlexFull>
                    <FlexCuz direction='row-reverse' position='fixed' right='0' bottom='0'>
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                        >
                            <AvanzarImg src={`/img/play.png`} /> 
                        </AvanzarBtn>
                    </FlexCuz>
                </Fragment>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default M62Practica;